import {computed, inject, Injectable, Signal} from "@angular/core";
import {Local} from "../configuration/config";
import {LocalConfigurationService} from "@fedelta-pos/data-client";
import {firstValueFrom} from 'rxjs';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {ConfigurationModel} from '../configuration/configuration.model';

export class TableLookupResponse {
    public id?: string;
    public storeGroup?: string;
    public exclusiveStoreGroup?: string;
    public stores?: number[];
    public exclusiveStores?: number[];
    public tableLookupCode?: string;
    public tableOnlyMode?: boolean;
    public pickupOnlyMode?: boolean;
    public redirectURL: string;
}

@Injectable()
export class ChewzieTableLookupService {
    private httpClient: HttpClient = inject(HttpClient);
    private configurationModel: ConfigurationModel = inject(ConfigurationModel);
    private localConfigurationService: LocalConfigurationService = inject(LocalConfigurationService);

    private readonly PROD_TABLE_LOOKUP_URL: string = "https://u.chewzie.me";
    private readonly STAGE_TABLE_LOOKUP_URL: string = "https://u.stage.chewzie.me";

    public readonly tableLookupUrl: Signal<string> = computed(() => this.configurationModel.production() ? this.PROD_TABLE_LOOKUP_URL : this.STAGE_TABLE_LOOKUP_URL);

    private loginToken: string;

    constructor() {
        console.log("--- ChewzieTableLookupService");
    }

    public async getLoginToken(): Promise<string> {
        if (!this.loginToken) {
            this.loginToken = await this.localConfigurationService.getString(Local.LOGIN_TOKEN);
        }
        return this.loginToken;
    }

    async lookupTable(scannedUrl: string): Promise<TableLookupResponse> {
        const url = new URL(this.tableLookupUrl() + "/lookup-table");
        url.searchParams.append("scannedUrl", btoa(scannedUrl));
        return Object.assign(new TableLookupResponse(), await firstValueFrom(this.httpClient.get(url.href, {
            headers: new HttpHeaders({token: await this.getLoginToken()}),
            observe: "body",
            responseType: "json"
        })));
    }
}
